// JavaScript Document 
// tech shoe animation 05-03-20

var current = 0,
    slides = document.getElementsByClassName("tech-shoe");

setInterval(function() {
  for (var i = 0; i < slides.length; i++) {
    slides[i].style.opacity = 0;
  }
  current = (current != slides.length - 1) ? current + 1 : 0;
  slides[current].style.opacity = 1;
}, 3000);